import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { midas } from '@resurs/midas'
import style from './dropdown.style'

export class Dropdown extends React.Component {
  constructor() {
    super()
    this.handleClick = this.handleClick.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.state = {
      dropdownVisible: false,
    }
  }

  handleClick(e, callback) {
    if (!this.state.dropdownVisible) {
      document.addEventListener('click', this.handleOutsideClick, false)
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false)
      if (callback) {
        e.preventDefault()
        callback(e)
      }
    }
    this.setState(prevState => ({
      dropdownVisible: !prevState.dropdownVisible,
    }))
  }

  handleOutsideClick(e) {
    if (this.node.contains(e.target)) {
      return
    }
    this.handleClick()
  }

  render() {
    let button
    if (this.props.list && this.props.list.length > 0) {
      button = (
        <button
          className={`${midas.button} ${midas.dropdownToggle} ${
            this.props.buttonStyle
          }`}
          style={
            this.props.buttonStyle !== midas.buttonLink
              ? Object.assign({}, style.borderDark, style.dark)
              : style.dark
          }
          onTouchStart=""
          onClick={e => this.handleClick(e)}
        >
          <i
            className={`${midas.icon} ${midas[this.props.icon]}`}
            style={style.iconDark}
          />
          {this.props.text}{' '}
          <i className={midas.iconCaret} style={style.caretDark} />
        </button>
      )
    } else {
      button = (
        <NavLink
          to={this.props.route}
          className={midas.button}
          style={style.dark}
        >
          {this.props.text}
        </NavLink>
      )
    }
    return (
      <div
        style={style.dropdown}
        className={`${midas.dropdownRight} ${this.props.className}`}
        ref={node => {
          this.node = node
        }}
      >
        {button}
        {this.state.dropdownVisible && (
          <ul style={style.menuVisible} className={midas.menu}>
            {this.props.list.map(item => (
              <li key={item.text} className={midas.menuItem}>
                {item.type === 'nav' ? (
                  <NavLink to={item.route} onClick={e => this.handleClick(e)}>
                    {item.text}
                  </NavLink>
                ) : (
                  <a
                    href={item.route}
                    onClick={e => this.handleClick(e, item.onClick)}
                  >
                    {item.text}
                  </a>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    )
  }
}
Dropdown.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  list: PropTypes.array,
  route: PropTypes.string,
  className: PropTypes.string,
  buttonStyle: PropTypes.string,
}

Dropdown.defaultProps = {
  icon: null,
  text: '',
  list: [],
  route: '/',
  className: '',
  buttonStyle: '',
}
